import { IconButton } from "@chakra-ui/react";
import { Tooltip } from '../components/ui/tooltip';
import { useColorMode } from "../components/ui/color-mode";
import { LuMoon, LuSun } from 'react-icons/lu';

export function ColorModeSwitcherButton() {
    const { colorMode, toggleColorMode } = useColorMode();
    const isDarkMode = colorMode === "dark";

    return (
        <Tooltip showArrow content="Toggle dark and light mode" openDelay={400}>
            <IconButton
                variant="outline"
                aria-label={isDarkMode ? "Toggle light mode" : "Toggle dark mode"}
                onClick={toggleColorMode}>{isDarkMode ? <LuSun color="yellow" /> : <LuMoon color="gray" />}</IconButton>
        </Tooltip>
    );
}
